<template>
    <!-- Modal -->
    <div class="modal fade" id="questionModal" tabindex="-1" aria-labelledby="questionModalLabel" aria-hidden="true">
        <div class="modal-dialog mw-100 bg-transparent ">
            <div class="  d-flex justify-content-center">
                <div class=" col-md-9 bg-light rounded">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="questionModalLabel">Question</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">×
                            </button>
                        </div>
                        <div class="card-body px-3">

                            <div class="row">
                                <div class="col-xl-8 col-lg-7 mt-4">
                                    <div class="card border-0 shadow rounded p-4 mb-3">
                                        <CurrentQuestion :currentQuestion="localItem" type="one"
                                                         :isEnd="isEnd"/>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-5 mt-4 rounded">
                                    <LinksAndMedia :currentQuestion="localItem" meta="{}" :isEnd="isEnd"/>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import Discuss_question_comment from "../question_sessions/discuss_question_comment.vue";
import CurrentQuestion from "../question_sessions/CurrentQuestion.vue";
import LinksAndMedia from "../question_sessions/LinksAndMedia.vue";
import questionFavorite from "../question_favorite/create.vue";

const toast = useToast();

export default {
    components: {questionFavorite, LinksAndMedia, CurrentQuestion, Discuss_question_comment},
    data() {
        return {
            localItem: []
        }
    },
    props: {
        question: {
            required: true
        }
    },
    watch: {
        'question': function (newVal) {
            if (newVal) {
                console.log(newVal);
                this.localItem = newVal;
                // this.showDialog();
                // this.openModal();
                // this.created();
                this.updateItem();
            }
        },
    },
    created() {
        // this.getItem();
    },
    methods: {
        isEnd(){
          return false;
        },
        // showDialog() {
        //     const confirmationModal = new bootstrap.Modal(document.getElementById('questionModal'));
        //     confirmationModal.show();
        //
        //     var firstDivContent = document.getElementById('questionModal');
        //     var secondDivContent = document.getElementById('modal-codes');
        //     secondDivContent.innerHTML = firstDivContent.innerHTML;
        //     firstDivContent.remove();
        // },
        updateItem() {
            if(this.question === null) return null;

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get(`questions/${this.question.id}`, {
                params: {
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            }).then(response => {
                // this.item = response.data.data;
                this.localItem = response.data.data;

                toast.dismiss(id);
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });
        },
        // openModal() {
        //     const modal = new bootstrap.Modal(document.getElementById('questionModal'));
        //     console.log(modal);
        //     modal.show();
        // }
    }
}
</script>
